import { isNull } from 'lodash';
import { PrmStudentCurriculumLessonReportResult } from 'types/schema-generated-types';

export const buildChartValues = (studentLessonReport: PrmStudentCurriculumLessonReportResult) => {
  const completedAndMet = studentLessonReport?.lessonDetail?.lessons.filter(
    x => !isNull(x.metSkill) && x.metSkill !== false
  );
  const allCompleted = studentLessonReport?.lessonDetail?.lessons.filter(x => !isNull(x.metSkill));

  const lessonsWithSupports =
    studentLessonReport?.lessonDetail?.lessons
      .filter(x => x.metSkill === true)
      .filter(x => x.usedSupport === true).length ?? 0;
  const lessonsWithoutSupports =
    studentLessonReport?.lessonDetail?.lessons
      .filter(x => x.metSkill === true)
      .filter(x => x.usedSupport === false).length ?? 0;

  const unmetLessons = studentLessonReport?.lessonDetail?.lessons.filter(x => x.metSkill === false);

  return {
    allCompleted: allCompleted?.length ?? 0,
    completedAndMet: completedAndMet?.length ?? 0,
    lessonsWithSupports,
    lessonsWithoutSupports,
    unmetLessons: unmetLessons?.length ?? 0
  };
};
